module.exports = __webpack_public_path__ + "img/cryo.0c2a60bf.png";